import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Callout = () => {
    return (
        <section>
            <Row className="flex-column p-3 px-5 p-sm-5">
                <Row className="pb-0">
                    <Col>
                        <h1 className="text-center">Thank you for joining us!</h1>
                    </Col>
                </Row>
            </Row>
        </section>
    );
}

export default Callout;